import React from "react";
import classNames from "classnames";

interface AppBarProps {
    className?: string;
    shadow?: number;
    position?: "static" | "fixed" | "sticky" | "absolute" | "bottom";
    color?: "" | "inherit" | "default" | "primary" | "secondary" | "shell";
    prominent?: boolean;
    prominentSize?: "sm" | "md" | "lg";
    children?: any;
    [x: string]: any;
}

export const AppBar = ({
    className = null,
    shadow = 4,
    position = null,
    color = null,
    prominent = false,
    prominentSize = null,
    children = null,
    ...props
}: AppBarProps) => {
    if (!color) color = "primary";
    if (shadow === undefined || shadow === null) shadow = 4;
    var cnShadow = shadow > 0 && shadow <= 24 ? `shadow-${shadow}` : "";
    var cn = classNames("appbar", className, cnShadow, {
        "appbar-fixed": position === "fixed",
        "appbar-fixed appbar-bottom": position === "bottom",
        "appbar-absolute": position === "absolute",
        "appbar-sticky": position === "sticky",
        "appbar-inherit": color === "inherit",
        "appbar-primary": color === "primary",
        "appbar-secondary": color === "secondary",
        "appbar-shell": color === "shell",
        "appbar-default": color !== "inherit" && color !== "primary" && color !== "secondary",
        "appbar-prominent-sm": prominent && prominentSize === "sm",
        "appbar-prominent": prominent,
        "appbar-prominent-lg": prominent && prominentSize === "lg",
    });

    return (
        <header className={cn} {...props}>
            {children}
        </header>
    );
};
